define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/topic",
	"csi/_base/underscore",
	"csi/page/SearchManager",
	"csi/resolver",
	"csi/state/rootStore",
	"csi/table/Widget",
	"csi/xml"
], function(declare,lang,topic,_,SearchManager,resolver,{ sessionStore },Widget,xml) {

	var FAVORITE_ITEM_URL= "__FavoriteItem__";

	return declare(Widget, {
		bForceBrowse: false,
		hideHeader: true,
		hideFooter: true,
		prefClass: null,
		
		postCreate: function() {
			this.inherited(arguments);
			topic.subscribe("/csi/favoriteTable/refresh", lang.hitch(this, this.refreshWidget));
		},

		postAction: function(/*Controller*/ac, /*Boolean*/bPendingAction) {
			this.inherited(arguments);
			topic.publish("/csi/pageHeader/refresh");
		},

		onCreateMainQueryLevel: function(/*QueryLevel*/ql) {
			var paths = [];
			var userPreferences = sessionStore.userPreferences;
			var favorites = resolver.m_cache.getNodes(userPreferences.Favorites);
			favorites.forEach(function(favorite){
				var childNode = resolver.m_cache.getChildNode(favorite,FAVORITE_ITEM_URL);
				if(childNode) {
					var path = SearchManager.getSearchQueryPaths(childNode.$Type);
					path = xml.path(FAVORITE_ITEM_URL,path);
					paths.push(path);
				}
			});
			ql.addDependencyPaths(paths);
		},
		
		/**
		* Return the image size based on view 
		* @return {string} -  the image size
		*/
		getDefaultImageSize: function() {
			return this.defView.defaultImageSize;
		}
	});
});